/**
 * Formats a date to short month day, year format (e.g. "Feb 5, 2025")
 * @param date - Date object or date string
 * @returns formatted date string
 */
export function formatShortDate(date: Date | string): string {
  const d = new Date(date);
  const month = d.toLocaleString('en-US', { month: 'short' });
  const day = d.getDate();
  const year = d.getFullYear();
  return `${month} ${day}, ${year}`;
}
